function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "invalid_svg__a",
  d: "M156.5 0C142.952 0 132 10.951 132 24.5c0 13.548 10.952 24.5 24.5 24.5S181 38.048 181 24.5C181 10.951 170.048 0 156.5 0zm12.25 33.295l-3.454 3.455-8.796-8.796-8.796 8.796-3.454-3.455 8.796-8.795-8.796-8.796 3.454-3.454 8.796 8.796 8.796-8.796 3.454 3.454-8.796 8.796 8.796 8.795z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#D0021B",
  transform: "translate(-132)",
  xlinkHref: "#invalid_svg__a"
});

var SvgInvalid = function SvgInvalid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/invalid.86f63230.svg";
export { SvgInvalid as ReactComponent };